import React from "react"

import { slugify } from "utils"

import { Container, Left, Right, VerticalPipe, PersonSvg, CheckSmallSvg, PlusSvg } from "./styles"

const SubcategoryHeadline = ({ subcategory, reviewer, personalStory }) => (
  <Container>
    <Left
      href={subcategory === "News" ? `/tag/${slugify(subcategory)}` : `/${slugify(subcategory)}`}
    >
      {subcategory}
    </Left>
    {(Boolean(reviewer) || personalStory) && (
      <Right>
        <VerticalPipe>|</VerticalPipe>
        {personalStory ? (
          <>
            personal story <PersonSvg id="plus-icon" width="14" height="15" />
          </>
        ) : (
          Boolean(reviewer) &&
          (reviewer.type === "fact-checked" ? (
            <>
              fact checked <CheckSmallSvg id="check-small-icon" width="15" height="11" />
            </>
          ) : (
            <a href={`/wc/${reviewer.url}`}>
              {reviewer.type === "medical" && (
                <>
                  medically reviewed <PlusSvg id="plus-icon" width="11" height="11" />
                </>
              )}
              {reviewer.type === "expert" && (
                <>
                  expert reviewed <CheckSmallSvg id="check-small-icon" width="15" height="11" />
                </>
              )}
            </a>
          ))
        )}
      </Right>
    )}
  </Container>
)

export default SubcategoryHeadline
